import {StoreType} from '../../../types/SharedTypes';

export const allAllianceSelector = (state: StoreType) => {
  return state.allianceReducer.allianceResponse;
}